import { Drawer } from '../../components'
import { useForecastBreakdown, type ForecastBreakdownItem } from '../../lib/api/forecast'

type Props = {
  organizationId: string
  week: string
  onClose: () => void
}

function fmt(n: number): string {
  return new Intl.NumberFormat('uk-UA', { maximumFractionDigits: 0 }).format(Math.abs(n))
}

function ItemRow({ item, sign }: { item: ForecastBreakdownItem; sign: '+' | '−' }) {
  const color = sign === '+' ? 'var(--success-fg, #22c55e)' : 'var(--danger-fg, #ef4444)'
  return (
    <tr>
      <td style={{ padding: '6px 8px', fontSize: 12, color: 'var(--fg-3)' }}>{item.date}</td>
      <td style={{ padding: '6px 8px', fontSize: 12 }}>{item.label}</td>
      <td style={{ padding: '6px 8px', fontSize: 12, color: 'var(--fg-4)' }}>{item.source}</td>
      <td style={{ padding: '6px 8px', fontSize: 13, textAlign: 'right', fontWeight: 500, color }}>
        {sign}{fmt(item.amount)} UAH
      </td>
    </tr>
  )
}

function SectionTable({
  title,
  items,
  sign,
}: {
  title: string
  items: ForecastBreakdownItem[]
  sign: '+' | '−'
}) {
  return (
    <div style={{ marginBottom: 20 }}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 600,
          color: 'var(--fg-3)',
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          marginBottom: 8,
        }}
      >
        {title} ({items.length})
      </div>
      {items.length === 0 ? (
        <p style={{ fontSize: 12, color: 'var(--fg-4)', padding: '8px 0' }}>Немає записів</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ borderBottom: '1px solid var(--border-default)' }}>
              <th style={{ padding: '4px 8px', textAlign: 'left', fontSize: 11, color: 'var(--fg-4)', fontWeight: 500 }}>Дата</th>
              <th style={{ padding: '4px 8px', textAlign: 'left', fontSize: 11, color: 'var(--fg-4)', fontWeight: 500 }}>Опис</th>
              <th style={{ padding: '4px 8px', textAlign: 'left', fontSize: 11, color: 'var(--fg-4)', fontWeight: 500 }}>Джерело</th>
              <th style={{ padding: '4px 8px', textAlign: 'right', fontSize: 11, color: 'var(--fg-4)', fontWeight: 500 }}>Сума</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <ItemRow key={`${item.source}-${item.date}`} item={item} sign={sign} />
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

export function BreakdownDrawer({ organizationId, week, onClose }: Props) {
  const { data, isLoading } = useForecastBreakdown({ organizationId, week })

  return (
    <Drawer title={`Деталі тижня ${week}`} onClose={onClose} width={560}>
      {isLoading ? (
        <p style={{ color: 'var(--fg-3)', fontSize: 13 }}>Завантаження…</p>
      ) : (
        <>
          <SectionTable
            title="Надходження"
            items={data?.incoming ?? []}
            sign="+"
          />
          <SectionTable
            title="Видатки"
            items={data?.outgoing ?? []}
            sign="−"
          />
        </>
      )}
    </Drawer>
  )
}
